import React, { useEffect, useState } from 'react';
import { ButtonPrimary } from '../../../../utils/Button';
import InputField from '../../../../utils/InputField';
import { useForgotPassword } from '../ForgottenProvider';

function ResendButton({ onClick }) {
    const [timeCount, setTimeCount] = useState(30);
    useEffect(() => {
        const interval = setInterval(() => {
            if (timeCount >= 1) {
                setTimeCount(timeCount - 1);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [timeCount]);
    return (
        <button
            type="button"
            onClick={() => onClick() + setTimeCount(60)}
            className={`h-10 text-sm w-[120px] uppercase text-primary-700 rounded-lg leading-10 transition-colors ${
                timeCount === 0
                    ? 'bg-secondary-200 text-secondary select-none'
                    : 'bg-primary-50 text-primary-700 pointer-events-none'
            }`}
        >
            {timeCount === 0 ? 'Resend Code' : `Resend in ${timeCount}s`}
        </button>
    );
}
function OtpCont() {
    const { formData, loading, handleChange, handleVerifyOTP, handleSendOtp } = useForgotPassword();

    // Focus on Input Field
    useEffect(() => {
        document.getElementsByTagName('input')[0].focus();
    }, []);

    return (
        <div className="h-[calc(100vh_-_60px)] md:h-screen w-screen flex items-center justify-center bg-transparent px-4 relative">
            <form
                onSubmit={handleVerifyOTP}
                className="w-[430px] shadow-[0px_4px_50px_0px_rgba(4,43,58,0.03)] mx-auto flex flex-col justify-between items-center gap-y-4 bg-white p-8 lg:p-16  rounded-20 md:rounded-30"
            >
                <div className="w-full">
                    <h1 className="text-base font-medium text-primary-700">
                        <span className="inline-block border-b border-secondary leading-8">
                            We Sent
                        </span>
                        &nbsp;OTP to
                    </h1>
                </div>
                <InputField
                    name="Code"
                    placeholder="Enter your OTP"
                    formData={formData}
                    onChange={handleChange}
                    height="h-10"
                    maxLength="6"
                />

                <div className="input-form flex justify-between items-center w-full mb-1 mt-2">
                    <ResendButton onClick={handleSendOtp} />

                    <ButtonPrimary title="Verify" btnType="submit" loading={loading} />
                </div>
            </form>
        </div>
    );
}

export default OtpCont;
